function GetSuggestedProducts() {

    if ($("#CurCatalogID").length > 0 && $(".AutoGetSuggested").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetSuggestedProducts",
            data: "ProductID=" + $("#ProductID").val() + "&CurCatalogID=" + $("#CurCatalogID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {

                dt = dt.replace("_buyuk", "_kucuk");

                $(".AutoGetSuggested .AutoSetted").remove();

                if (dt != "") {

                    //$(".AutoGetSuggested").html(dt);

                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-sm-6");
                    //$(".AutoGetSuggested .ProductList .Prd").addClass("col-xs-12");
                    //$(".AutoGetSuggested .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    $(".AutoGetSuggested").append(dt);

                    $(".AutoGetSuggested img").each(function () {
                        $(this).attr("src", $(this).attr("data-src"));
                    });

                    //$(".AutoGetSuggested .ProductList").removeClass("grid-wrapper").addClass("grid-wrapper-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd").removeClass("grid").addClass("grid-product-details");
                    //$(".AutoGetSuggested .ProductList .Prd a .img2").remove();
                    $(".AutoGetSuggested .Productsuggest .ProductList").addClass("col-xs-24");

                }

                //if ($(window).width() < 767) {

                SuggestPrdSlider();
                //}


            }
        });
    }
}

function addQuantity() {
    $(".AmountOptions a").live("click", function () {
        var InputItem = $(this).closest(".AmountOptions").find("#Amount");
        if ($(this).hasClass("BasketPlus")) {
            InputItem.attr('value', parseInt(InputItem.val()) + 1);
        }
        if ($(this).hasClass("BasketMinus") && InputItem.val() > 0) {
            InputItem.attr('value', parseInt(InputItem.val()) - 1);
        }

    });
}

function GetHashImage() {
    if (window.location.hash != undefined && window.location.hash != "") {
        var colorHash = window.location.hash.split("=");
        var ColorID = colorHash[1];
        currentColorID = $(".Colors a.active:first").attr("data-id");

        if (currentColorID != ColorID) {
            if ($(".ProductDetail .Colors a[data-id='" + ColorID + "']").length > 0) {
                $(".ProductDetailImages picture").remove();
                $(".ProductDetail .Colors a[data-id='" + ColorID + "']").trigger("click");
            }
        }
        else if ($("#CurCatalogID").length > 0) {
            GetSuggestedProducts();
            GetCombineProducts();
        }
    }
}

var LastVisitedPrds = [];

function GetLastVisitedPrdView(productData) {

    if ($(".AutoGetLastVisited").length > 0) {

        //var prdDataList = "";
        //for (var i = 0; i < productData.length; i++) {

        //    prdDataList += "lastviewedPrds.[" + i + "].Amount=" + productData[i].Amount;
        //    LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, ProductName: _prdname });

        //}
        $.ajax({
            type: "POST",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetLastVisitedProductsView",
            data: JSON.stringify(productData),
            //contentType:"text/html",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {


                $(".LastViewedProducts.AutoSetted").remove();

                if (dt != "") {

                    $(".AutoGetLastVisited").append(dt);

                    $(".LastViewedProducts .ProductList .Prd").addClass("col-sm-6");
                    $(".LastViewedProducts .ProductList .Prd").addClass("col-xs-12");
                    $(".LastViewedProducts .ProductList .Prd a .img2").remove();

                }

            }
        });
    }
}


$("#SingOut").live("click", function (e) {
    if (!isAppleMobile()) {
        localStorage.removeItem("LastVisitedPrds");
    }

});

function SetLastVisitedProductsStorage() {

    if (typeof (Storage) !== "undefined") {

        if ($(".ProductHeader:first").length > 0) {

            var hours = 8; // Reset when storage is more than 24hours
            var now = new Date().getTime();
            var setupTime = localStorage.getItem('prdLastSetupTime');

            if (setupTime == null) {
                localStorage.setItem('prdLastSetupTime', now)
            } else {
                if (now - setupTime > hours * 60 * 60 * 1000) {
                    localStorage.removeItem("LastVisitedPrds");
                    localStorage.setItem('prdLastSetupTime', now);
                }
            }

            var _productid = $("#ProductID:first").val();
            var _colorid = $("#ColorID:first").val();
            var _url = window.location.pathname;
            var _prdImg = $("meta[property$=image]").attr("content");
            var _prdname = $(".ProductHeader:first").text();
            var _amount = $(".PriceItem:first").text();

            _prdname = _prdname.replace(/(\r\n|\n|\r)/gm, "").trim();

            LastVisitedPrds = localStorage.LastVisitedPrds;

            if (LastVisitedPrds == undefined) {
                LastVisitedPrds = [];
            } else {
                LastVisitedPrds = JSON.parse(LastVisitedPrds);
            }

            var itemExist = false;

            for (var i = 0; i < LastVisitedPrds.length; i++) {

                if (LastVisitedPrds[i].ColorID == _colorid && LastVisitedPrds[i].ProductID == _productid) {
                    itemExist = true;
                }
            }

            if (!itemExist) {

                LastVisitedPrds.push({ Amount: _amount, ProductID: _productid, ColorID: _colorid, Url: _url, Img1: _prdImg, Img2: _prdImg.replace("_1_", "_2_"), ProductName: _prdname });

                if (LastVisitedPrds.length > 6) {
                    LastVisitedPrds.shift();
                }

                localStorage.LastVisitedPrds = JSON.stringify(LastVisitedPrds);
            }

            if (LastVisitedPrds != undefined && LastVisitedPrds.length > 0) {

                GetLastVisitedPrdView(LastVisitedPrds);
            }


        }
    } else {
        console.warn("Tarayıcının localstorage desteği bulunmuyor.");
    }

}

function Get5thAngleCombine() {

    //if ($(".CombineProductsOnPd .Prd").length > 0) {

    //    var imagePath1thAngle = $(".CombineProductsOnPd .Prd:first .img1").attr("src");

    //    var ImgExist = false;
    //    var BeginAngle = 5;
    //    var NewImagePathAngle = "";
    //    $curImg = $(".CombineProductsOnPd .ProductList .Prd:first .img1");

    //    if (!ImgExist && $curImg.attr("src").indexOf("5_buyuk") <= 0) {

    //        NewImagePathAngle = imagePath1thAngle.replace("1_buyuk", "1_buyuk");

    //        ImgExist = true;

    //        $curImg.attr("src", NewImagePathAngle);

    //        $curImg.error(function () {
    //            $curImg.attr("src", imagePath1thAngle);
    //        });

    //    }

    //}
}

function ReplaceCombineProducts() {


    if ($(".CombineProductsOnPd .Prd").length > 0) {

        //$(".CombineProductsOnPd .Prd:first").append('<div class="equals">=</div>');
        $(".CombineProductsOnPd .Prd:first > a").attr("href", $(".CombineButton").attr("href"));
        $(".CombineProductsOnPd .Prd:first .PName").html($(".CombineButton").attr("data-title"));

        $priceSpan = $(".CombineProductsOnPd .Prd:first .PPrice span").clone();
        $combineButton = $(".CombineInfoPd .CombineButton").clone();

        $(".CombineProductsOnPd .Prd:first .PPrice").remove();
        $(".CombineProductsOnPd .Prd:first").append($combineButton);

        $(".CombineProductsOnPd .Prd:gt(0)").addClass("SmallPrd");

        Get5thAngleCombine();

    }

}

function GetCombineProducts() {

    if ($("#CurCatalogID").length > 0 && $(".CombineItems").length > 0) {

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetCombineProducts",
            data: "ProductID=" + $("#ProductID").val() + "&ColorID=" + $(".Colors a.active:first").attr("data-id"),
            cache: false,
            success: function (dt) {

                $(".CombineProductsOnPd").remove();

                if (dt != "") {

                    $(".SuggestAndLast.CombineItems").append(dt);
                    ReplaceCombineProducts();

                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-sm-6");
                    $(".Suggesteds .Productsuggest .ProductList .Prd").addClass("col-xs-12");

                    //$(".Suggesteds .Productsuggest .ProductList .Prd:gt(3)").addClass("hidden-xs");

                    $(".CombineProductsOnPd .ProductList .Prd:first").removeClass("col-xs-12").addClass("col-xs-24");

                    $(".CombineProductsOnPd .ProductList:first-child").removeClass("col-md-4").addClass("col-md-5");
                    $(".CombineProductsOnPd .ProductList:first-child").css("padding-right", "10px");



                    Get5thAngleCombine();
                }

            }
        });
    }
}

function DetailResizing() {

    $(".CombineProductsOnPd .Productsuggest .ProductList").addClass("col-xs-24");


    if ($(window).width() <= 991) {

        $(".ProductDetailsMainImage ul li img").each(function () {
            $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x919"))
        });
    }


    $(window).resize(function () {


        if ($(window).width() <= 991) {

            $(".ProductDetailsMainImage ul li.ImgArea img").each(function () {
                $(this).attr("src", $(this).attr("src").replace("_buyuk", "_614x919"))
            });
        }


    });


}


function AskQuestions() {

    $("body").on("click", ".AskQuestion", function () {
        $("#AskQuestion").modal();
    });

    $('#AskQuestion').on('shown.bs.modal', function () {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/AskQuestions",
            contentType: 'application/json; charset=utf-8',
            cache: false,
            success: function (dt) {
                $("#AskQuestion  .formArea").html("");

                $("#AskQuestion  .formArea").html(dt);
                $("#AskQuestion  .formArea .HiddenItems").find("#ColorID").val($(".Colors div a.active").data("id"));
                $("#AskQuestion  .formArea .HiddenItems").find("#ProductID").val($(".Prices #ProductID").val());
            }
        });
    });
}

function SizeTable() {

    $(".SizeTable").live("click", function () {
        $("#SizeTable").modal();
    });
}

function BasketButtonFixed() {
    $(window).scroll(function () {

        if ($("body").hasClass("Scrolled")) {

            $("#Basket").addClass("BasketFixed");

        }
        else {
            $("#Basket").removeClass("BasketFixed");
        }

    });
}

function CombinePrdSlider() {
    var slidesToShowNumber = 2;

    if ($(window).width() < 767) {
        slidesToShowNumber = 1;
    }
    $(".CombineProductsOnPd img.img2").remove();

    $(".CombineProductsOnPd .ProductList .ProductList").slick({
        nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
        slidesToShow: slidesToShowNumber,
        slidesToScroll: 1,
        arrows: true,
        useTransform: false,
    });

}

function SuggestPrdSlider() {

    $(".AutoGetSuggested img.img2").remove();

    $(".AutoGetSuggested .ProductList .ProductList").slick({
        nextArrow: '<div class="PrdDetayImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdDetayImgLeft left-arrow"></div>',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        useTransform: false,
    });

}

function Slider() {
    $('.ProductDetailsMainImage ul').slick({
        nextArrow: '<div class="PrdImgRight right-arrow"></div>',
        prevArrow: '<div class="PrdImgLeft left-arrow"></div>',
        infinite: true,
        slidesToShow: 1,
        arrows: true
    });

    var count = $('.SmallProductImages li').size();

    $('.SmallProductImages ul').slick({
        slidesToShow: 4,
        slidesToScroll: count,
        asNavFor: '.ProductDetailsMainImage ul',
        prevArrow: '<div class="yukariIcon"></div>',
        nextArrow: '<div class="asagiIcon"></div>',
        focusOnSelect: true,
        vertical: true
    });

    $('.ProductDetailsMainImage ul').on('swipe', function (event, slick, direction) {
        $(".PrdImgLeft").trigger("click");
    });
}

function AddToFavoriteNewPd() {

    var ColorID = $("#ColorID").val();
    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".passiveFavorite").live("click", function () {
        $That = $(this);

        if (ColorID != undefined && ProductID != undefined) {

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToFollowList",
                data: 'colorID=' + ColorID + "&productID=" + ProductID,
                dataType: 'json',
                async: true,
                success: function (dt) {

                    if (dt.Sonuc == true) {

                        $That.addClass("activeFavorite");
                        $That.removeClass("passiveFavorite");
                    }
                    else if (dt.Sonuc == false) {
                        alert('Favorilere eklemek için giriş yapınız!');
                    }

                },
                error: function (httpObj, textStatus) {

                    //if (httpObj.status == 401) {
                    //    alert('Favorilere Eklemek için giriş yapınız.');
                    //}

                    //else {
                    alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    //}

                }
            });
        }
    });

}

function removeFavoriteNewPd() {

    var ProductID = $("#ProductID").val();

    $("#ProductDetailDivi").find(".activeFavorite").live("click", function () {
        $That = $(this);

        if (ProductID != undefined) {
            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/RemoveFromList",
                data: 'id=' + ProductID + "&IsDetail=true",
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if (dt.Sonuc == true) {
                        $That.addClass("passiveFavorite");
                        $That.removeClass("activeFavorite");
                    }


                },
                error: function (httpObj, textStatus) {

                    if (httpObj.status == 401) {
                        alert('Favorilerden çıkartmak için giriş yapınız.');
                    }

                    else {
                        alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
                    }

                }
            });
        }
    });

}

$("body").on("submit", ".AskQuestionForm", function (e) {

    $.ajax({
        type: 'post',
        url: $(".AskQuestionForm").attr("action"),
        data: $(".AskQuestionForm").serialize(),
        async: true,
        success: function (dt) {

            if (dt.Sonuc == true) {

                $("#Infos").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);

                $(".AskQuestionForm").hide();

            }
            else {

                $("#AlertResult").addClass("alert-danger");
                $("#AlertResult").addClass("alert-error").show().find("span").html(dt.IslemSonucAciklama);
            }

        },
        error: function () {

            alert('Talebiniz yerine getirilirken bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.!');
        }
    });

    e.preventDefault();
    return false;

});

$('#StoreStocksbtn').live("click", function (e) {
    var ProductID = $("#ProductID").val();
    var ColorID = $("#ColorID").val();
    var SizeID = $("#StoreStockOptionsDetail select[name='BedenMagazaAra']").val();

    if ((SizeID != null && SizeID != undefined && SizeID != "") && (ColorID != null && ColorID != undefined && ColorID != "") && (ProductID != null && ProductID != undefined && ProductID != "")) {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetStoreStocks?ProductID=" + ProductID + "&ColorID=" + ColorID + "&SizeID=" + SizeID,
            success: function (data) {

                $(".StoreStockBody").html(data);

            }
        });
    }
    else {

        if (SizeID == null || SizeID == undefined || SizeID == "") {
            alert("Lütfen Beden Seçiniz..");
        }
        else if (ColorID == null || ColorID == undefined || ColorID == "") {
            alert("Lütfen Renk Seçiniz..");
        }
        else if (ProductID == null || ProductID == undefined || ProductID == "") {

            alert("Bir hata oluştu lütfen sayfayı yenileyerek tekrar deneyiniz.");

        }

    }
});

function WhatssappOrder() {
    var CName = $("#CName").val();
    if ($(window).width() < 767 && CName == "ProductDetails") {
        var LangID = $("#LangID").val();
        var SmallLangCode = $("#SmallLangCode").val();

        var whatsappOrderLink = "https://api.whatsapp.com/send?phone=905337341417&text=";

        var whatsappOrderText = "";
        if (SmallLangCode == "en" || LangID == "2") {
            whatsappOrderText = "Hi, i want to order this product, Product Link : ";
        }
        else if (SmallLangCode == "fr" || LangID == "3") {
            whatsappOrderText = "Salut, je veux commander ce produit, lien de produit : ";
        }
        else {
            whatsappOrderText = "Sipariş vermek istiyorum, Ürün Linki : ";
        }

        whatsappOrderLink = whatsappOrderLink + whatsappOrderText + window.location.href;
        $(".ContactWhatsapp a").attr("href", whatsappOrderLink);
        $(".ContactWhatsapp").css("bottom", "70px");
        $(".top_link").css("display", "none");
    }
}

function LazyToDataImg() {
    if ($(window).width() > 767) {
        $NextOrPrevSlide = $(".ProductDetail .ProductDetailsMainImage .slick-slider li.slick-active img");
        if ($NextOrPrevSlide.attr("src").indexOf("lazy_back.jpg") != -1) {
            $NextOrPrevSlide.attr("src", $NextOrPrevSlide.attr("data-img"));
        }
    }
    else {

        $(".ProductDetail .ProductDetailsMainImage ul li.ImgArea img").each(function (index) {
            if ($(this).attr("src").indexOf("lazy_back.jpg") != -1) {
                $(this).attr("src", $(this).attr("data-img"));
            }
        });
    }
}

function FancyboxOlustur() {
    var selector = '.fancybox.slick-slide:not(.slick-cloned)';
    $().fancybox({
        selector: selector,
        buttons: [
            "zoom",
            //"share",
            "slideShow",
            //"fullScreen",
            //"download",
            "thumbs",
            "close"
        ],
        afterLoad: function (instance, current) {
            instance.group.map(function (i) {
                i.thumb = i.src.replace('_enbuyuk', '_kucuk');
                return i;
            });
        }
    });
}

function GetProductComment(RequestData, callback) {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetProductComment",
        data: RequestData,
        cache: false,
        success: function (data) {
            callback(true, data);
        },
        error: function (dt) {
            callback(false, "");

            alert("Yorumlar yüklenirken bir hata oluştu.");
        }
    });
}

$(document).ready(function () {

    ProductComment();

    $(".CombineProductsOnPd .Prd:eq(1)").addClass("col-md-offset-2");

    AskQuestions();
    SizeTable();
    Slider();
    //ImageFix();
    AddToFavoriteNewPd();
    removeFavoriteNewPd();
    WhatssappOrder();
    $miniImage = $('.SmallProductImages ul');
    CombinePrdSlider();
    DetailResizing();

    if (!isAppleMobile()) {
        SetLastVisitedProductsStorage();
    }

    GetSuggestedProducts();
    //GetLastVisitedProducts();
    ReplaceCombineProducts();
    BasketButtonFixed();
    FancyboxOlustur();


    if ($(".CombineProductsOnPd .ProductList .Prd").length > 0) {
        $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-6");
    }

    //SEPETE EKLE
    $(".AddToBasket.ProductDetails #Basket").live("click", function (e) {


        var SizeID = $("#SizeID").val();
        var ColorID = $("#ColorID").val();
        var ProductID = $("#ProductID").val();
        var Amount = $("#Amount").val();
        var LangID = $("#LangID").val();
        var BedenSec = $('#BedenSec').val();
        var RenkSec = $('#RenkSec').val();
        var UrunYok = $('#UrunYok').val();

        $basketButton = $(this);

        if (SizeID != undefined && ColorID != undefined && ProductID != undefined && SizeID != "" && ColorID != "" && ProductID != "") {

            var NormalText = $basketButton.text();
            var AddingText = $basketButton.attr("data-adding");
            $basketButton.text(AddingText);

            $.ajax({
                type: 'get',
                url: "/" + $("#SmallLangCode").val() + "/p/Cart/AddToCart",
                data: 'sizeID=' + SizeID + "&colorID=" + ColorID + "&productID=" + ProductID + "&adet=" + Amount + "&langID=" + LangID,
                dataType: 'json',
                async: true,
                success: function (dt) {
                    if ($(window).width() < 768) {
                        $basketButton.html("<div class='BasketIcon hidden-md hidden-lg'></div>" + NormalText);
                    }
                    else {
                        $basketButton.text(NormalText);
                    }

                    $("#GeneralModal .modal-header span").html(dt.IslemSonucAciklama);

                    if (dt.Sonuc == true) {

                        $Modal = $("div#QuickLookModal");

                        if ($Modal.length > 0) {
                            $Modal.modal("hide");
                        }

                        $.ajax({
                            type: 'get',
                            url: "/" + $("#SmallLangCode").val() + "/p/Cart/GetSepetIcerik",
                            data: "",
                            async: true,
                            contentType: "application/json; charset=utf-8",
                            dataType: 'text',
                            success: function (dt) {

                                $("#UserMenus > #UserAndBasket").html(dt);

                                $('html, body').animate({ scrollTop: 0 }, 'slow');

                                $(".RightBasket").addClass("active");
                                $("body").addClass("BackDropped");

                                $(".SepetProducts").hide();
                                $(".SepetProducts").addClass("activeBasket");

                                setContentHeight();
                            }
                        });


                        if (typeof UseSwStat != 'undefined' && UseSwStat == true) {

                            var basketParams = GetSwPageParams();

                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ActionType", "SepeteEkleme");
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ProductID", ProductID);
                            basketParams = ChangeSwHashedStringParamValue(basketParams, "ColorID", ColorID);
                            basketParams += "&CatalogID=" + $("#CurCatalogID").val();

                            AddSwAction(basketParams);

                        }

                        if (UseTagManager) {

                            SendCartAddEvent('');
                        }


                    }
                    else {

                        alert(dt.IslemSonucAciklama);
                    }


                }
            });




        }
        else {
            if (SizeID == undefined || SizeID == "") {


                $("#PrdBlackBg").show();
                $(".SizeOptions.open").addClass("PleaseSelect");
                $(".AddToBasket").addClass("PleaseSelect");
                //$("body").addClass("BackDropped");

                $('html, body').animate({
                    scrollTop: $(".SizeOptions").offset().top - 150
                }, 500);


                if ($(".AutoTextRep").length > 0) {

                    $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                    $(".AddToBasket button").text($('#BedenSec').val());

                    $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ColorID == undefined || ColorID == "") {

                alert(RenkSec);

                $(".AddToBasket button").attr("data-first", $(".AddToBasket button").text());
                $(".AddCombineToBasket button").attr("data-first", $(".AddCombineToBasket button").text());

                if ($(".AutoTextRep").length > 0) {
                    $(".AddToBasket button").text($('#BedenSec').val());
                    $(".AddCombineToBasket button").text($('#BedenSec').val());
                }

            }

            if (ProductID == undefined || ProductID == "") alert(UrunYok);


        }

        e.preventDefault();
        return false;

    });

    //if (isMobile(false)) {

    //    $("#Basket").on("hover", function (e) {

    //        $(".AddToBasket.ProductDetails  #Basket").trigger("click");


    //    });

    //}

    //Ürün Beden Seçimi
    $('.SizeOptions a:not(.NotifyWhen)').live("click", function () {

        $(this).parents(".Sizes").find(".Name").html($(this).attr("data-name"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));
        $(this).parents(".Sizes").find("#SizeID").val($(this).attr("data-id"));

        $(this).parent().find("a").removeClass("active");
        $(this).addClass("active");



        if ($(".NewPD").length > 0) {

            $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("passed");

            $(".Colors span.ChooseTitle").removeClass("current");
            $(".Colors span.ChooseTitle").addClass("passed");

            $(".Sizes span.ChooseTitle").removeClass("current");
            $(".Sizes span.ChooseTitle").addClass("passed");

            $(".SizeAndAmount  > span.ChooseTitle").removeClass("current");
            $(".SizeAndAmount  > span.ChooseTitle").addClass("passed");

            $(".AmountOptions  span.ChooseTitle").removeClass("passed");
            $(".AmountOptions  span.ChooseTitle").addClass("current");


            var TrigAddBasket = false;

            if ($(".SizeOptions.PleaseSelect").length == 1) {
                TrigAddBasket = true;
            }


            //$(".AmountOptions").addClass("open");

            $(".AddToBasket button").removeClass("NotSelected");


            if ($(".AutoTextRep").length > 0 && $(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0 && $(".EsPD").length <= 0) {

                $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
            }

            $(".SizeOptions").removeClass("PleaseSelect");

            $(".AddToBasket").removeClass("PleaseSelect");

            $("#PrdBlackBg").hide();

            if (TrigAddBasket) {
                $(".AddToBasket #Basket").click();
            }

        }

        if ($(".LastProducts").length > 0) {

            var params = "ProductID=" + $("#ProductID").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $("#SizeID").val();

            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/StokWarn",
                data: params,
                success: function (data) {

                    if (data != "0" && data != 0) {

                        var prdCls = "More";

                        $(".LastProducts").removeClass("One");
                        $(".LastProducts").removeClass("Two");
                        $(".LastProducts").removeClass("More");
                        $(".LastProducts").removeClass("Limited");

                        $(".LastX").html(data);
                        $(".LastPrdHint").html($(".LastPrdHint").attr("data-more"));

                        //if (data.length > 1) {
                        //    $(".LastX").css("margin-left", "2px");
                        //}
                        //else {
                        //    $(".LastX").css("margin-left", "4px");
                        //}

                        switch (data) {

                            case "1": prdCls = "One"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-one")); break;
                            case "2": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "3": prdCls = "Two"; $(".LastPrdHint").html($(".LastPrdHint").attr("data-twotree")); break;
                            case "": prdCls = "gizli"; $(".LastPrdHint").html(""); break;
                            case "4": prdCls = "Limited"; break;

                        }

                        $(".LastProducts").addClass(prdCls);
                        $(".LastProducts").show();

                    }
                }

            });

        }


    });

    if ($(".SizeOptions .ONE.SIZE").length > 0) {

        $(".SizeOptions .ONE.SIZE").trigger("click");
        //$(".SizeAndAmount").hide();
    }


    $("a.NotifyWhen").live("click", function myfunction() {

        $("#NotifyModal").modal("show");


        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetListForRemind?ProductID=" + $("#ProductID:first").val() + "&ColorID=" + $("#ColorID").val() + "&SizeID=" + $(this).parent().parent().parent().find("input[name=SizeIDs]").val(),
            cache: true,
            success: function (data) {

                $("#NotifyModal .modal-body").html(data);
                $(".NotifyColors a:first").trigger("click");
            }
        });


    });

    var lastColorID = 0;

    if ($('.ProductDetail .Colors a.active').length > 0) {
        $(".ProductDetail .Colors .Name").html($('.ProductDetail .Colors a.active').first().attr("data-name"));
    }

    GetHashImage();

    $(window).bind('hashchange', function (e) {

        GetHashImage();

    });

    if ($("div.row.Products").length > 0) {

        var ScrollSize = +70;
        var offsetTop = 0;

        if (isMobile(true)) {
            ScrollSize = 50;
            offsetTop = $(".ToogleFilters:first").offset().top;

        } else if ($("#FilterForm").length > 0) {

            //offsetTop = $("#FilterForm").offset().top
        }

        if (isMobile(true)) {

            $('html, body').animate({
                scrollTop: offsetTop - ScrollSize
            }, 500);
        }

    }

    addQuantity();

    $('.ProductDetail #Amount').live("keyup", function () {

        var yeniAdet = $(this).val();
        $adetKutusu = $(this);

        if (!isNumeric(yeniAdet)) {
            yeniAdet = 1;
        }

        if (yeniAdet <= 1) {

            yeniAdet = 1;
            $adetKutusu.val(1);
        }
        else if (yeniAdet >= 9) {

            yeniAdet = 9;
            $adetKutusu.val(9);
        }

    });

    $(".AmountOptions #Amount").live("change", function () {

        if ($(".AmountOptions #Amount").val() < 1) {

            $(".AmountOptions #Amount").val(1);
        }
        else if ($(".AmountOptions #Amount").val() >= 9) {

            $(".AmountOptions #Amount").val(9);
        }

    });


    $(".SmallProductImages ul li img").live("click", function () {



        $(".SmallProductImages ul li img").each(function () {

            $(this).removeClass("Selected");

        });

        $(this).addClass("Selected");
        $Index = $(this).parent().index();
        $(".ProductDetailImages ul li.ImgArea").addClass("gizli");
        $(".ProductDetailImages ul li.ImgArea").each(function () {
            if ($Index === $(this).index()) {
                $(this).removeClass("gizli");
            }
        });

    });

    $('.ProductDetailImages ul').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $miniImage.slick("slickGoTo", currentSlide);

        $(".SmallProductImages ul li").each(function () {
            if ($(this).data("slick-index") == currentSlide) {

                $("img", this).addClass("Selected");

            }
            else {

                $("img", this).removeClass("Selected");

            }



        });


    });


    $('.ProductDetailImages .ImgArea a').live("click", function (e) {

        if (isMobile(true) || $(this).closest("#QuickLookModal").length > 0) {

            return false;
            e.preventDefault();
        }

    });

    if ($(window).width() > 1000 && $(".cloudzoomManuel").length > 0 && $("#QuickLookModal").length <= 0) {

        $(".cloudzoomManuel:first").addClass("cloud-zoom").CloudZoom();

    }

    if ($(".Productsuggest").length > 0 && $(".backdrop").length > 0) {

        $(".Productsuggest > .ProductList .Prd").addClass("col-sm-8");
        $(".Productsuggest > .ProductList .Prd").addClass("col-xs-12");
        //$(".Productsuggest > .ProductList .Prd:gt(3)").addClass("hidden-xs");
    }


    if ($(".ProductLastViewedCon").length > 0 && $(".backdrop").length > 0) {

        $(".ProductLastViewedCon .Prd").addClass("col-sm-6");
        $(".ProductLastViewedCon .Prd").addClass("col-xs-12");
        $(".ProductLastViewedCon .Prd:gt(3)").addClass("hidden-xs");
    }

    $("a.SizeTableLink").click(function () {

        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");

        $("#WarningModal").modal("show");

        var ProductID = $(this).closest(".ProductName").next(".CombineColors").find(".ProductID").val();
        var ColorID = $(this).closest(".ProductName").next(".CombineColors").find(".ColorID").val();

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/SizeChart?ProductID=" + ProductID + "&ColorID=" + ColorID,
            success: function (data) {

                $("#WarningModal .modal-body").html(data);

            }
        });

    });

    $(".ProductDetailImages .PrdImgRight").click(function (e) {

        $("#AditionalDescription").remove();

        LazyToDataImg(); // Lazy Load imajını data-img ile değiştirir

        $currentObject = $(".ProductDetailImages ul li.ImgArea");
        if ($currentObject.not(".mobile-hidden").index() == ($currentObject.length - 1)) {

            $currentObject.addClass("mobile-hidden").first(".ImgArea").removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").next(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {
            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });
    });

    $(".ProductDetailImages .PrdImgLeft").click(function (e) {

        $("#AditionalDescription").remove();

        LazyToDataImg(); // Lazy Load imajını data-img ile değiştirir

        $currentObject = $(".ProductDetailImages ul li.ImgArea");

        if ($currentObject.not(".mobile-hidden").index() == 0) {

            $currentObject.addClass("mobile-hidden");
            $currentObject.last().removeClass("mobile-hidden");

        } else {

            $currentObject.not(".mobile-hidden").addClass("mobile-hidden").prev(".ImgArea").removeClass("mobile-hidden");

        }

        $(".SmallProductImages ul li img").each(function () {


            $ItemIndex = $currentObject.not(".mobile-hidden").index();
            if ($currentObject.not(".mobile-hidden").index() == $(this).parent().index()) {
                $(this).addClass("Selected");
            }

            $(".SmallProductImages ul li img").each(function () {
                if ($(this).parent().index() != $ItemIndex) {
                    $(this).removeClass("Selected");
                }

            });
        });

    });

    $(".ProductDetail .ProductDetailImages .SmallProductImages .slick-slide img").live("click", function () {

        var selectedIndex = $(this).parent().attr("data-slick-index");

        $(".ProductDetail .ProductDetailsMainImage .slick-slider li.ImgArea").each(function (index) {

            if ($(this).attr("data-slick-index") == selectedIndex) {

                $(this).children("img").attr("src", $(this).children("img").attr("data-img"));

            }
        });

    });


    //if ($(window).width() < 993) {


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swipeleft", function (e) {

    //        $(".PrdImgLeft").trigger("click");
    //        //e.stopPropagation();
    //        // e.preventDefault();
    //    });


    //    $(".ProductDetailImages .ImgArea  img").hammer().on("swiperight", function (e) {

    //        $(".PrdImgRight").trigger("click");
    //        //e.stopPropagation();
    //        //e.preventDefault();
    //    });

    //}


    var isOpen = false;
    $('.PdInstallmentOptions, .PrInstallmentOptions').live("click", function (e) {

        var Amount = $(".PriceItem:first").html();

        var isPr = $(this).hasClass("PrInstallmentOptions");

        var campaignAmount = $(".LastDiscount strong").html();

        //alert("campaignAmount: " + campaignAmount);

        if (campaignAmount != undefined && campaignAmount != "") {
            Amount = campaignAmount.replace(",", ".");
        }

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetInstallmentOptions?Amount=" + Amount.replace(",", ""),
            success: function (data) {

                isOpen = !isOpen;
                $(".InstallmentBody").html(data);
                if (isPr) {
                    $("#PdInstallmentOptionsDetail").addClass("collapse in");
                }

                if (isOpen) {

                    $('html, body').animate({
                        scrollTop: $("#PdInstallmentOptionsDetail").offset().top - 50
                    }, 500);
                }

            }
        });

    });


    $(".PrAdvantages a").click(function (e) {
        $("#WarningModal .modal-header h3").html($(this).text().replace("|", ""));
        $("#WarningModal .modal-body").html("");
        $("#WarningModal").modal("show");
        var ProductID = $("#ProductID").val();
        var ColorID = $("#ColorID").val();
        var Amount = parseFloat($(".PriceItem:first").html());

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAdvantages?ProductID=" + ProductID + "&ColorID=" + ColorID + "&Amount=" + Amount,
            success: function (data) {
                $("#WarningModal .modal-title").hide();
                $("#WarningModal .modal-body").html(data);
            }
        });
    });


    $(".SmallImageList li").live("click", function () {
        var ImageIndex = $(this).index();
        $(".ProductImageList li").removeClass("selectedImage");
        $(".SmallImageList li").removeClass("selectedImage");
        $(this).addClass("selectedImage");
        $(".ProductImageList li").each(function () {
            if ($(this).index() == ImageIndex) {
                $(this).addClass("selectedImage");
            }
        });

    });

    $(".ThumbImageList li img").live("click", function (event) {
        event.stopPropagation();
        $sliderSlick.slick("slickGoTo", $(this).parent().index());

        $(".ThumbImageList li img").each(function () {

            $(this).removeClass("ThumbActive");

        });

        $(this).addClass("ThumbActive");

    });

    $('.ProductBigSeen').on('afterChange', function (event, slick, currentSlide, nextSlide) {

        $(".ThumbImageList li img").each(function () {
            if ($(this).parent().index() == currentSlide) {
                $(this).addClass("ThumbActive");
            }
            else {
                $(this).removeClass("ThumbActive");
            }


        });




    });
});


$(".Colors #changeColor").live("click", function (e) {
    var LangID = $("#LangID").val();
    var ProductID = $(this).attr("data-productID");
    var ColorID = $(this).attr("data-id");

    $(".Colors .active").removeClass("active");
    $(this).addClass("active");
    $(".AddToFavorite").attr("data-id", ProductID);

    $("#PID").val(ProductID);
    $("#ProductID").val(ProductID);
    $("#ColorID").val(ColorID);
    var count = 0;

    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/getProductDetailAjax?ProductID=" + ProductID + "&ColorID=" + ColorID + "&LangID=" + LangID,
        async: true,
        cache: false,
        beforeSend: function () {
            // alert("beforeSend");
        },
        success: function (data) {
            $.each(data, function (k, v) {
                if (count === 0) {
                    getSizeInfo(ColorID, ProductID);

                    if ($("#SmallLangCode").val() == "tr") {
                        $(".Colors .Name").html(v.ColorName);
                        $(".ProductHeader").html(v.ColorName + " " + v.ProductName);
                        $(".Prices .PrdouctCode").html(v.ProductCode);
                        $(".ViewerCount .PriceOld").html(v.AmountOld);
                        $(".ViewerCount .Price ").html(v.Amount);
                        $("#PrdInfo > .panel-inner").html(v.DetailHTML);
                        $(".LastProducts").css("display", "none");

                        if (v.CampaignAmount != undefined && v.CampaignAmount != "") {
                            $(".LastDiscount strong ").text(v.CampaignAmount);
                        }
                    }
                    else {
                        $(".Colors .Name").html(v.ColorLangName);
                        $(".ProductHeader").html(v.ColorLangName + " " + v.ProductName);
                        document.title = v.ColorLangName + " " + v.ProductName;
                        $(".Prices .PrdouctCode").html(v.ProductCode);
                        $(".ViewerCount .PriceOld").html(v.AmountOld);
                        $(".ViewerCount .Price ").html(v.Amount);
                        $("#PrdInfo > .panel-inner").html(v.DetailHTML);

                        if (v.CampaignAmount != undefined && v.CampaignAmount != "") {
                            $(".LastDiscount strong ").text(v.CampaignAmount);
                        }
                    }
                }
                count++;
            });

            // #region ProductImages
            $(".ProductDetailsMainImage > ul").slick('unslick');
            if ($(window).width() > 991) {
                $(".SmallProductImages > ul").slick('unslick');
            }

            // #region SmallProductImages
            if ($(window).width() > 991) {
                $(".SmallProductImages > ul li").remove();
            }
            $(".ProductDetailsMainImage > ul li").remove();

            $.each(data, function (k, v) {
                if (v.ImagePath != null && v.ImagePath != undefined && v.ImagePath != "") {

                    var Images = v.ImagePath.split(';');
                    $.each(Images, function (k, v) {

                        if (v.includes(".webp")) {
                            var a1 = v.replace("_buyuk", "_enbuyuk");
                            var a2 = v;

                            var a3 = v.replace(".webp", ".jpg");;

                            var str = '<li class="ImgArea fancybox" href="' + a1 + '"><picture><source data-srcset="' + a1 + '" type="image/webp"/><source data-srcset="' + a3 + '" type="image/jpeg" /><img class="lazyload" data-src="' + a2 + '" src="' + a1 + '"/></picture></li>';

                            $(".ProductDetailsMainImage > ul").append(str);
                        }
                        else {

                            var a1 = v.replace("_buyuk", "_enbuyuk");
                            var a2 = v;

                            var str = '<li class="ImgArea fancybox" href="' + a1 + '"><picture><source data-srcset="' + a1 + '" type="image/webp"/><source data-srcset="' + a1 + '" type="image/jpeg" /><img class="lazyload" data-src="' + a2 + '" src="' + a1 + '"/></picture></li>';

                            $(".ProductDetailsMainImage > ul").append(str);
                        }

                        if ($(window).width() > 767) {

                            if (v.includes(".webp")) {
                                var a2 = v.replace("_buyuk", "_kucuk");

                                var str2 = '<li><picture><source data-srcset="' + a2 + '" type="image/webp"/><source data-srcset="' + a2 + '" type="image/jpeg" /><img class="lazyload" data-src="' + a2 + '" src="' + a2 + '"/></picture></li>';

                                $(".SmallProductImages > ul").append(str2);
                            }
                            else {

                                var a3 = v.replace("_buyuk", "_kucuk");

                                var str3 = '<li><picture><source data-srcset="' + a3 + '" type="image/webp"/><source data-srcset="' + a3 + '" type="image/jpeg" /><img class="lazyload" data-src="' + a3 + '" src="' + a3 + '"/></picture></li>';

                                $(".SmallProductImages > ul").append(str3);
                            }
                        }
                    });

                    return false;
                }
            });

            setTimeout(function () {
                Slider();
            }, 500);

            getCombineProducts(ProductID, ColorID);
        },
        error: function () {
            alert('Talebiniz yerine getirilirken bir hata oluştu.');
        },
        complete: function () {
            // alert("complete");
        }
    });
});

function getSizeInfo(colorID, productID) {
    var params = "ColorID=" + colorID + "&ProductID=" + productID;
    var c = 0;
    var img = "";
    var width = window.screen.width;
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetAllDetailInfoByColorID",
        data: params,

        success: function (data) {
            $selectSizePopup = $(".SizeOptions #SelectSizePopup");

            if ($selectSizePopup.length > 0) {

                $selectSizePopup = $(".SizeOptions #SelectSizePopup").clone();
            }

            $(".SizeOptions").html("");
            $(".SizeOptions").append("<span class='ChooseTitle hidden-xs open current'>Beden</span>");
            $(".ReminderSizeOptions").html("");

            if ($selectSizePopup.length > 0) {
                $(".SizeOptions").append($selectSizePopup);
            }

            // GetNewPrices
            $.ajax({
                type: "GET",
                url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetDetailProductPrice",
                data: "ProductID=" + productID,
                success: function (newData) {
                    $.each(newData, function (k, v) {
                        if (v.Type === "Prices") {
                            $(".PriceOld").html(v.AmountOld);
                            $(".Price").html(v.Amount);

                            if (v.CampaignPrice != "") {
                                $(".LastDiscount strong").html(v.CampaignPrice);
                                var lastDist = $(".LastDiscount strong").html();
                                $(".LastDiscount strong").html(lastDist.replace(".", ","));
                            }
                        }
                    });
                },
                error: function () {
                    alert("Talebiniz yerine getirilirken bir hata oluştu.");
                }
            });
            // GetNewPrices

            // GetNewColorSize
            var newSizeCount = 0;
            $.each(data, function (k, v) {
                if (v.Type == "Size") {
                    var stil = "";
                    if (v.InStock == false || v.PStatus != 1) {

                        stil = "OutOfQuantity";

                        if ($(".NewPD").length > 0) {
                            $(".SizeOptions").append('<span class=\"outer\">' +
                                '  <span class="PdHint"> <span class="PdHint-content">Bu Ürünün ' + v.Name + ' Bedeni Stoklarla Kalmamıştır.<br />' +
                                '<a href="#" class="NotifyWhen">Ürün stoğa geldiğinde haber ver!</a>' +
                                ' </span><i class="reactangle"></i></span>'
                                + '<span class=\"inner\">' + v.Name + '</span></span>');



                        } else {
                            $(".SizeOptions").append('<span class=\"outer\"><span class=\"inner\">' + v.Name + '</span></span>');
                        }

                        $('.AddToRemindList').show();
                    }
                    else {
                        newSizeCount++;

                        var standartClass = "";
                        if (v.Name == "Standart") {
                            standartClass = " active";
                            $("#SizeID").val(v.ID);
                        }

                        $(".SizeOptions").append("<input type='hidden' name='SizeID' id='SizeID' value=" + v.ID + ">");
                        $(".SizeOptions").append('<a data-id="' + v.ID + '" data-stock="' + v.InStock + '" data-name="' + v.Name + '" href="javascript:void(0)" class="' + stil + " " + v.Name + '">' + v.Name + '</a>');
                    }

                }
            });

            if (newSizeCount == 0) {
                $(".ProductContent .BadgesArea").css("display", "unset");

                if ($("#SmallLangCode").val() === "tr") {
                    var badgeArea = "<div class='PDIConItem'><img src='/Images/TTE/badge/tukendi.png' alt='Bu ürün stoklarımızda tükenmiştir.'>";
                }
                else if ($("#SmallLangCode").val() === "en") {
                    var badgeArea = "<div class='PDIConItem'><img src='/images/TTE/badge/sold_out.png' alt='This product is out of stock'>";
                }
                else if ($("#SmallLangCode").val() === "fr") {
                    var badgeArea = "<div class='PDIConItem'><img src='/images/TTE/badge/epuise.png' alt='This product is out of stock'>";
                }

                badgeArea += '<div class="text-tooltip hidden-xs hidden-sm"><span class="reactangle"></span><span class="text">Bu ürün stoklarımızda tükenmiştir.</span></div ></div>';

                $(".ProductContent .BadgesArea .PdIcons").html(badgeArea);
                //alert("stok sıfır");
            }
            else {
                $(".ProductContent .BadgesArea").css("display", "none");
            }

            // GetNewColorSize
            if ($(".NewPD").length > 0) {

                $(".SizeOptions, .SizeAndAmount span.ChooseTitle").addClass("open");

                $(".Colors span.ChooseTitle").removeClass("current");
                $(".Colors span.ChooseTitle").addClass("passed");

                $(".SizeAndAmount span.ChooseTitle").addClass("current");
                $(".SizeAndAmount span.ChooseTitle").removeClass("passed");

                $(".AmountOptions span.ChooseTitle").removeClass("current");
                $(".AmountOptions span.ChooseTitle").removeClass("passed");

                $(".AmountOptions").removeClass("open");

                $(".Sizes").find(".Name").html("");

                $(".AddToBasket button").addClass("NotSelected");
                $(".AddCombineToBasket button").addClass("NotSelected");

                if ($(".AddToBasket button").attr("data-first") != undefined && $(".AddToBasket button").attr("data-first").length > 0) {
                    $(".AddToBasket button").text($(".AddToBasket button").attr("data-first"));
                }

                if ($(".AddCombineToBasket button").attr("data-first") != undefined && $(".AddCombineToBasket button").attr("data-first").length > 0) {
                    $(".AddCombineToBasket button").text($(".AddCombineToBasket button").attr("data-first"));
                }

            }


            if ($(".SizeOptions .ONE.SIZE").length > 0) {

                $(".SizeOptions .ONE.SIZE").trigger("click");
                $(".SizeAndAmount").hide();
            }
            else {
                $(".SizeAndAmount").show();
            }

            //$.fancybox.destroy();
            //FancyboxOlustur();
        },
        error: function () {
            alert('Hatalı talep!');
        }

    });
}

function getCombineProducts(ProductID, ColorID) {

    if ($(".SuggestAndLast.CombineItems").length > 0) {
        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetCombineProductsForAjax?ProductID=" + ProductID + "&ColorID=" + ColorID,
            async: true,
            cache: false,
            success: function (data) {
                if (data) {

                    $(".SuggestAndLast.CombineItems .CombineProductsOnPd .Productsuggest").html(data);
                    $(".CombineProductsOnPd .Prd:eq(1)").addClass("col-md-offset-2");
                    $(".CombineProductsOnPd .Productsuggest .ProductList").addClass("col-xs-24");
                    $(".Productsuggest > .ProductList .Prd").addClass("col-sm-8");
                    $(".Productsuggest > .ProductList .Prd").addClass("col-xs-12");

                    $(".CombineProductsOnPd .ProductList .Prd").removeClass("col-md-8").addClass("col-md-6");

                    CombinePrdSlider();
                    LazyLoad();
                }
            },
            error: function () {
                alert('Talebiniz yerine getirilirken bir hata oluştu.');
            }
        });
    }
}

function ProductComment() {
    RatingStarts();

    $(document).on("click", ".ProductDetail .ProductComments #AddComment, .ProductDetail .ProductComments .FirstComment", function () {
        var ProductID = $("#PID").val();

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/CommentLoginControl",
            data: "ProductID=" + ProductID,
            cache: false,
            success: function (data) {

                data = JSON.parse(data);

                if (data.CanComment == false) {
                    SwalGenerate("error", "Resmi gazetede çıkan yeni yönetmeliğe göre ürün yorumlarını sadece ürünü satın alan müşteriler yapabilir. Anlayışınız için teşekkür ederiz.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
                }
                else if (data.IsLogin == false) {
                    var loginLink = "/" + $("#SmallLangCode").val() + "/p/User/Login";
                    SwalGenerate("warning", "Yorum yapabilmek için giriş yapmalısınız.", getStandartMessages("IslemBasarisiz"), "<a href='" + loginLink + "'>" + getStandartMessages("GirisYap") + "</a>");
                }
                else {
                    if (data.HasComment == false) {
                        RateStarsOperation("destroy");
                        RateStarsOperation("init");

                        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

                        if (!$("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").addClass("disabled");
                        }
                    }
                    else {

                        $Stars = $("#CommentModal .RateStars");
                        $Stars.rateYo("rating", data.Rating);
                        $("#CommentModal .modal-body .CommentInputArea textarea").val(data.Comment);

                        if (!data.ShowName) {
                            $("#CommentModal .modal-body .CheckItem.ShowName .AllowCheck").removeClass("checked");
                        }

                        if ($("#CommentModal .modal-footer a").hasClass("disabled")) {
                            $("#CommentModal .modal-footer a").removeClass("disabled");
                        }
                    }

                    $("#CommentModal").modal();
                }
            },
            error: function (dt) {
                //window.location.href = "/tr/p/User/Login";
            }
        });
    });

    $(document).on("click", ".js-load-more-comment", function () {

        var ProductID = $(this).attr("data-productid");

        var LangID = $("#LangID").val();

        var PageNo = $(this).attr("data-pageNo");

        var Filter = "";

        var RequestData = "ProductID=" + ProductID + "&LangID=" + LangID + "&PageNo=" + PageNo;

        if ($(".js-filter-item-element.active").length > 0) {
            Filter = $(".js-filter-item-element.active").first().attr("data-rate");

            RequestData += "&filter=" + Filter;

            // alert("ok.");
        }
        GetProductComment(RequestData, function (status, data) {
            if (status) {
                $(".js-load-more-comment").parent(".LoadMore").remove();

                $(".CommentArea").append(data);
            }
        });
    });

    $(document).on("click", "#CommentModal .modal-footer a", function () {
        $button = $(this);

        if (!$(this).hasClass("disabled")) {

            var getRating = RateStarsOperation("get");
            var errMsg = "";

            if (getRating < 1 || getRating > 5) {
                errMsg = $("#CommentModal .RateWarning").text();
            }

            if (errMsg != "") {
                SwalGenerate("error", errMsg, getStandartMessages("Hata"), getStandartMessages("Kapat"));
            }
            else {
                var ProductCode = "";
                var LangID = $("#LangID").val();
                var ProductID = $("#PID").val();
                var ColorID = $("#ColorID").val();
                var Comment = $("#CommentModal .modal-body .CommentInputArea textarea").val();
                var AllowShowName = $("input[type='checkbox'][name='ShowName']").prop("checked");

                var param = "ProductID=" + ProductID + "&ColorID=" + ColorID + "&ProductCode=" + ProductCode + "&Rate=" + getRating + "&Comment=" + Comment + "&ShowName=" + AllowShowName + "&LangID=" + LangID;

                var CurrentText = $button.text();
                $button.text($button.attr("data-adding") + "...");

                $.ajax({
                    Type: "GET",
                    url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/AddComment",
                    data: param,
                    cache: false,
                    success: function (data) {

                        data = JSON.parse(data);

                        if (data.Sonuc == false) {
                            SwalGenerate("error", data.IslemSonucAciklama, getStandartMessages("Hata"), getStandartMessages("Kapat"));
                        }
                        else {
                            $("#CommentModal").modal("hide");

                            $ConfirmModal = $("#ConfirmCommentModal");
                            $ConfirmModal.modal("show");
                            $ConfirmModal.find(".ResultText").text(data.IslemSonucAciklama);
                        }

                        $button.text(CurrentText);

                        $Commentbutton = $(".ProductComments #AddComment");
                        $Commentbutton.text($Commentbutton.attr("data-UpdateCommentText"));

                    },
                    error: function (data) {
                        SwalGenerate("error", "Sistemde bir hata oluştu. Lütfen bizimle iletişime geçiniz.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
                        $button.text(CurrentText);
                    }
                });
            }
        }
    });

    $(document).on("click", "#CommentModal .modal-body .CommentLabel  .CommentCriterias", function () {
        $("#CommentCriteriasModal").modal("show");
    });

    $(document).on("click", "#ConfirmCommentModal .modal-footer a", function () {
        $("#ConfirmCommentModal").modal("hide");
    });

    $("#ConfirmCommentModal").on('hide.bs.modal', function () {
        location.reload();
    });

    /////////////////////////////////////////////////////////////////

    $(document).on("click", ".btn-comment", function () {
        UserCommentRatingStarts();

        $("#CommentModal .modal-body .CommentInputArea textarea").val("");

        var ProductID = $(this).attr("data-id");
        var ColorID = $(this).attr("data-color-id");
        var UserRate = $(this).attr("data-user-rating");

        $.ajax({
            type: "GET",
            url: "/" + $("#SmallLangCode").val() + "/p/User/CommentModal",
            data: "ProductID=" + ProductID + "&ColorID=" + ColorID + "&UserRate=" + UserRate,
            cache: false,
            success: function (data) {
                data = JSON.parse(data);

                RateStarsOperation("destroy");
                RateStarsOperation("init");

                if (data.UserRate !== null) {
                    $Stars = $("#CommentModal .RateStars");
                    $Stars.rateYo("rating", data.UserRate);
                    //console.log(data.UserRate)
                }

                $("#comment-image").attr('src', data.ImagePath);
                $(".CommentModalProductContent .CmpContent .PdName").html(data.ProductName);
                $("#PID").val(data.ProductID);
                $(".comment-modal-color-id").val(data.ColorID);
                $(".CommentInputArea textarea").val(data.Comment);

                $("#CommentModal").modal();

                $('#Private-Close-Modal').click(function () {
                    $('#CommentModal').modal('hide');
                });

            },
            error: function (dt) {
                //window.location.href = "/tr/p/User/Login";
            }
        });

    });
}

function GetProductComment(RequestData, callback) {
    $.ajax({
        type: "GET",
        url: "/" + $("#SmallLangCode").val() + "/p/ProductDetails/GetProductComment",
        data: RequestData,
        cache: false,
        success: function (data) {
            callback(true, data);
        },
        error: function (dt) {
            callback(false, "");
            SwalGenerate("error", "Yorumlar yüklenirken bir hata oluştu.", getStandartMessages("Hata"), getStandartMessages("Kapat"));
        }
    });
}

function RatingStarts() {
    $Stars = $("#CommentModal .RateStars");

    RateStarsOperation("init");

    // Rate Stars Change Method
    $Stars.rateYo()
        .on("rateyo.set", function (e, data) {
            $("#CommentModal .RateWarning").hide();
            $("#CommentModal .modal-footer a").removeClass("disabled");
        });

    $("#CommentModal .CommentModalCheckList .CheckItem").on("click", function () {
        $(this).children(".AllowCheck").toggleClass("checked");
    });
}

function RateStarsOperation(operation) {
    $Stars = $("#CommentModal .RateStars");

    if (operation == "init") {
        $Stars.rateYo({
            rating: 0,
            fullStar: true
        });
    }
    else if (operation == "destroy") {
        $Stars.rateYo("destroy");
    }
    else if (operation == "get") {
        return $Stars.rateYo("rating");
    }
}